import Vue from 'vue';
import { parseBoolean } from '~/lib/utils/common_utils';
import { initReportAbuse } from '~/projects/report_abuse';
import MrMoreDropdown from '~/vue_shared/components/mr_more_dropdown.vue';

export const initMrMoreDropdown = () => {
  const el = document.querySelector('.js-mr-more-dropdown');

  if (!el) {
    return false;
  }

  const {
    mergeRequest,
    url,
    editUrl,
    isCurrentUser,
    canUpdateMergeRequest,
    open,
    merged,
    sourceProjectMissing,
    clipboardText,
    reportedUserId,
    aiOverviewAvailable,
    aiOverviewEnabled,
  } = el.dataset;

  let mr;

  try {
    mr = JSON.parse(mergeRequest);
  } catch {
    mr = {};
  }

  return new Vue({
    el,
    name: 'MrMoreDropdownRoot',
    provide: {
      reportAbusePath: el.dataset.reportAbusePath,
    },
    beforeCreate() {
      initReportAbuse();
    },
    render: (createElement) =>
      createElement(MrMoreDropdown, {
        props: {
          mr,
          url,
          editUrl,
          isCurrentUser,
          canUpdateMergeRequest,
          open,
          isMerged: merged,
          sourceProjectMissing,
          clipboardText,
          reportedUserId: Number(reportedUserId),
          aiOverviewAvailable: parseBoolean(aiOverviewAvailable),
          aiOverviewEnabled: parseBoolean(aiOverviewEnabled),
        },
      }),
  });
};
